import './styles/section.promo-bar.scss';
import { isNullOrUndef } from '../js/helpers/isNullOrUndef';
import { isNotNullOrUndef } from '../js/helpers/isNotNullOrUndef';
class SectionPromoBar extends HTMLElement {
    bar = this.querySelector('.promo-bar');
    couponDesktop = this.querySelector('.hidden\\:sm .promo-bar__coupon');
    couponDesktopText = this.couponDesktop?.textContent ?? '';
    couponMobile = this.querySelector('.hidden\\:md-up .promo-bar__coupon');
    couponMobileText = this.couponMobile?.textContent ?? '';
    successPopup = this.querySelector('.promo-bar__success');
    tooltip = this.querySelector('.tooltip--copy');
    discountCode = this.dataset.discountCode;
    successCloseTimer = 0;
    constructor() {
        super();
        this.bar?.addEventListener('click', this.copy.bind(this));
        this.successPopup?.addEventListener('click', () => {
            this.successCloseTimer !== 0 && clearTimeout(this.successCloseTimer);
            this.successPopup?.setAttribute('aria-hidden', 'true');
        });
        if (window.innerWidth >= 1024 && isNotNullOrUndef(this.tooltip)) {
            this.addEventListener('mousemove', (e) => {
                if (isNullOrUndef(this.tooltip))
                    return;
                this.tooltip.style.top = `${e.clientY + 20}px`;
                this.tooltip.style.left = `${e.clientX + 20}px`;
            });
        }
    }
    copy() {
        if (isNullOrUndef(this.discountCode) || isNullOrUndef(this.bar))
            return;
        if (isNotNullOrUndef(window.navigator.clipboard)) {
            navigator.clipboard.writeText(this.discountCode)
                .then(() => {
                this.showSuccess();
            })
                .catch(error => {
                console.log('Copy error:', error);
            });
        }
        else {
            const input = document.createElement('input');
            input.value = this.discountCode;
            this.bar.appendChild(input);
            input.select();
            input.setSelectionRange(0, 99999);
            document.execCommand('copy');
            this.bar.removeChild(input);
            this.showSuccess();
        }
    }
    showSuccess() {
        const coupon = window.innerWidth >= 768
            ? this.couponDesktop
            : this.couponMobile;
        const couponText = window.innerWidth >= 768
            ? this.couponDesktopText
            : this.couponMobileText;
        if (isNotNullOrUndef(coupon)) {
            coupon.textContent = 'COPIED!';
            this.successCloseTimer !== 0 && clearTimeout(this.successCloseTimer);
            this.successCloseTimer = window.setTimeout(() => {
                if (isNotNullOrUndef(coupon)) {
                    coupon.textContent = couponText;
                }
            }, 2500);
        }
        else {
            if (isNullOrUndef(this.successPopup))
                return;
            const flipperContainer = this.successPopup.closest('.promo-bar-flipper');
            this.successPopup.setAttribute('aria-hidden', 'false');
            isNotNullOrUndef(flipperContainer) && (flipperContainer.style.transform = 'rotateX(180deg)');
            this.successCloseTimer !== 0 && clearTimeout(this.successCloseTimer);
            this.successCloseTimer = window.setTimeout(() => {
                this.successPopup?.setAttribute('aria-hidden', 'true');
                isNotNullOrUndef(flipperContainer) && (flipperContainer.style.transform = '');
            }, 2500);
        }
    }
}
customElements.define('promo-bar-component', SectionPromoBar);
